<script>
import getInfoMixin from './getInfoMixin'
export default {
  name: 'getStagesInfo',
  mixins: [ getInfoMixin ],
  data() {
    return {
      email: window.user_email
    }
  },
  
  render(h) {
    return this.$scopedSlots.default({
      gotIt: () => this.receiveInfo(),
      loginAndGot: () => this.openLogin(),
      load: this.load
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/js/shared/components/GetStagesInfo.vue